import axios from "axios";
import { STATIC_URL } from "./env";
import { getAuthentication } from "./auth";
import { IMultiLanguage } from "../types/MutliLanguage";

export function renderMultilangText(text: IMultiLanguage): string {
  return text.En || text.Ar || text.Fr || "";
}

export type GqlRequestOptions = {
  query: string;
  endpoint: string;
  headers?: Record<string, string>;
};

interface GqlResponse<T> {
  data?: T;
  errors?: { message: string }[];
}

export async function gqlRequest<T>({
  query,
  endpoint,
  headers = {},
}: GqlRequestOptions): Promise<GqlResponse<T>> {
  const defaultHeaders = {
    "Content-Type": "application/json",
    "Cache-Control": "no-store",
    Pragma: "no-cache",
    Expires: "0",
  };

  const mergedHeaders = { ...defaultHeaders, ...headers };

  try {
    const response = await axios.post(
      endpoint,
      { query },
      { headers: mergedHeaders }
    );

    const result: GqlResponse<T> = response.data;
    if (result.errors && result.errors.length > 0) {
      throw {
        type: "GraphQL",
        errors: result.errors,
        message: `GraphQL errors: ${result.errors
          .map((e) => e.message)
          .join(", ")}`,
      };
    }

    return result;
  } catch (error) {
    throw error;
  }
}

export function escapeGqlString(str: string): string {
  if (typeof str !== "string") return "";
  return str
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/\n/g, "\\n")
    .replace(/\r/g, "\\r");
}

export const formatKey = (key: string): string => {
  return key.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const getCounter = async (key: string): Promise<number | undefined> => {
  const gqlString = `query{
    GetCounter(key:"${key}")
  }`;
  try {
    const response = await gqlRequest<{ GetCounter: number }>({
      query: gqlString,
      endpoint: STATIC_URL,
      headers: {
        authorization: `Bearer ${getAuthentication()}`,
      },
    });

    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }
    if (response.data?.GetCounter) return response.data?.GetCounter;
    else return 0;
  } catch (error) {}
};
